var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(3309 3134)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 32,
    height: 32,
    transform: "translate(-3309 -3134)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M14.709,3c2.662,0,4.821,2.23,4.821,5.351,0,6.243-6.574,9.811-8.765,11.149-1.733-1.058-6.209-3.512-8-7.581H6.879L7.7,10.531l2.63,4.459,1.811-3.071h3.01V10.135h-4l-.818,1.388L7.7,7.064,5.886,10.135h-3.7A8.663,8.663,0,0,1,2,8.351C2,5.23,4.191,3,6.821,3a5.756,5.756,0,0,1,3.944,1.784A5.756,5.756,0,0,1,14.709,3Z",
    transform: "translate(-3303.765 -3129.108)",
    fill: "#787c7c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.c25f08b3dc9b714176b3354d67d2a411.svg";
export { ForwardRef as ReactComponent };